import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TravelRequestQueue = ({ requests }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'approved': return 'success';
      case 'pending_approval': return 'warning';
      case 'rejected': return 'error';
      case 'draft': return 'muted';
      case 'completed': return 'secondary';
      default: return 'muted';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'error';
      case 'normal': return 'secondary';
      case 'low': return 'muted';
      default: return 'muted';
    }
  };

  const getTravelTypeIcon = (type) => {
    switch (type) {
      case 'international': return 'Globe';
      case 'domestic': return 'MapPin';
      case 'emergency': return 'AlertTriangle';
      default: return 'Plane';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="glass-container rounded-xl border border-border/50">
      <div className="p-6 border-b border-border/50">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Travel Request Queue</h3>
            <p className="text-sm text-muted-foreground mt-1">
              {requests?.length || 0} active travel requests
            </p>
          </div>
          <Button variant="ghost" size="sm" iconName="Filter">
            Filter
          </Button>
        </div>
      </div>
      <div className="divide-y divide-border/50">
        {requests?.map((request) => (
          <div
            key={request?.id}
            className="p-6 hover:bg-white/5 transition-colors duration-200"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center border text-${getPriorityColor(request?.priority)} bg-${getPriorityColor(request?.priority)}/10 border-${getPriorityColor(request?.priority)}/20`}>
                  <Icon name={getTravelTypeIcon(request?.travelType)} size={24} />
                </div>
                <div>
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-semibold text-foreground">{request?.requestNumber}</h4>
                    <span className={`px-2 py-1 rounded text-xs font-medium text-${getStatusColor(request?.status)} bg-${getStatusColor(request?.status)}/10`}>
                      {request?.status?.replace('_', ' ')?.toUpperCase()}
                    </span>
                    {request?.priority === 'high' && (
                      <span className="px-2 py-1 rounded text-xs font-medium text-error bg-error/10">
                        HIGH PRIORITY
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">
                    {request?.travelerName} • {request?.department}
                  </p>
                  <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                    <div className="flex items-center space-x-1">
                      <Icon name="MapPin" size={14} />
                      <span>{request?.destination}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Calendar" size={14} />
                      <span>{formatDate(request?.startDate)} - {formatDate(request?.endDate)}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="DollarSign" size={14} />
                      <span>${request?.estimatedBudget?.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <Button variant="ghost" size="sm" iconName="Eye">
                  View
                </Button>
                {request?.status === 'pending_approval' && (
                  <>
                    <Button variant="outline" size="sm" iconName="Check">
                      Approve
                    </Button>
                    <Button variant="ghost" size="sm" iconName="X">
                      Reject
                    </Button>
                  </>
                )}
              </div>
            </div>

            <div className="bg-muted/20 rounded-lg p-3">
              <p className="text-sm text-foreground">
                <span className="font-medium">Purpose:</span> {request?.purpose}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TravelRequestQueue;